import { useMemo } from 'react';
import { ObjectSchema, string } from 'yup';
import { addressWithCountrySchema, IResidenceForm } from '../../shared';
import { useTranslation } from 'react-i18next';

export function useResidenceSchema(): ObjectSchema<IResidenceForm> {
    const { t } = useTranslation();

    return useMemo(
        () =>
            addressWithCountrySchema(t).shape({
                livingSituation: string().optional(),
                familySituation: string().optional(),
            }),
        [t],
    );
}
